<template>
  <canvas class="canvas-class" ref="my-canvas" width="1024" height="512"></canvas>
</template>

<script>
import 'yuki-createjs'
/* eslint-disable */

const preload = new createjs.LoadQueue()
const self = this
var slotroller = {
  roller: null,
  cb: null,
  init: function (rollerStill, rollerMoving, rollerTop) {
    var rollerBgStill = new createjs.Container()
    var rollerImage = new createjs.Bitmap(rollerStill)
    var rollerImage2 = new createjs.Bitmap(rollerStill)
    rollerImage2.y = 1125
    rollerBgStill.addChild(rollerImage)
    rollerBgStill.addChild(rollerImage2)
    var rollerBgMoving = new createjs.Container()
    var rollerImage = new createjs.Bitmap(rollerMoving)
    var rollerImage2 = new createjs.Bitmap(rollerMoving)
    rollerImage2.y = 1125
    rollerBgMoving.addChild(rollerImage)
    rollerBgMoving.addChild(rollerImage2)
    rollerBgMoving.alpha = 0
    var rollerContainer = new createjs.Container()
    var rollerTop = new createjs.Bitmap(rollerTop)
    this.roller = new createjs.Container()
    this.roller.addChild(rollerBgStill)
    this.roller.addChild(rollerBgMoving)
    var rollermask = new createjs.Shape()
    rollermask.graphics.beginFill(createjs.Graphics.getRGB(0, 0, 0)).drawRect(0, 0, 225, 450).endFill()
    this.roller.mask = rollermask
    rollerContainer.addChild(this.roller)
    rollerContainer.addChild(rollerTop)
    this.roller.y = -2 * 1125 + 562

    return rollerContainer
  },
  start: function ( rolls, offset, cb ) {
    this.roller.getChildAt(1).alpha = 1;
    this.roller.y = -2 * 1125 + 562;
    var startPos = this.roller.y;
    if (rolls == 2) {
      createjs.Tween.get(this.roller, {loop: false})
        .to({y: startPos + 1125}, 500, createjs.Ease.getPowIn(2))
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125}, 500, createjs.Ease.linear())
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125 + 225 * offset}, 500, createjs.Ease.getPowOut(2))
        .call(cb, [this.roller, false])
    }
    if (rolls == 3) {
      createjs.Tween.get(this.roller, {loop: false})
        .to({y: startPos + 1125}, 500, createjs.Ease.getPowIn(2))
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125}, 500, createjs.Ease.linear())
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125}, 500, createjs.Ease.linear())
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125 + 225 * offset}, 500, createjs.Ease.getPowOut(2))
        .call(cb, [this.roller, false])
    }
    if (rolls == 4) {
      createjs.Tween.get(this.roller, {loop: false})
        .to({y: startPos + 1125}, 500, createjs.Ease.getPowIn(2))
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125}, 500, createjs.Ease.linear())
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125}, 500, createjs.Ease.linear())
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125}, 500, createjs.Ease.linear())
        .to({y: startPos}, 1, createjs.Ease.linear())
        .to({y: startPos + 1125 + 225 * offset}, 500, createjs.Ease.getPowOut(2))
        .call(cb, [this.roller, false])
        .wait(500)
        .call(cb, [this.roller, true])
    }
  }
  // soundEffect("spin");
}

export default {
  props: ['texts'],
  components: {},
  name: 'WheelOfFortune',
  data: function () {
    return {
      queue: null,
      stage: null,
      result: null,
      roller1: null,
      roller2: null,
      roller3: null,
      isRolling: false,
      rollpot: 0,
      pot: 0,
      pots: [0,0,0,0,10,20,30,50,100,200],
      offsets: [[0,-2,-1],[0,-1,0],[2,2,-1],[-2,2,0],[1,-2,-1],[1,1,0],[1,1,1],[0,0,0],[-1,-1,-1],[2,2,2]]
    }
  },
  methods: {
    spin: function () {
      if (!this.isRolling) {
        var luck = Math.round( Math.random()*(this.pots.length-1) );
        this.pot = this.pots[luck];

        if( this.rollpot == 5 ){ // stop bad luck before it's too late
          luck = 6;
          this.rollpot = 0;
          this.pot = this.pots[luck];
        }
        else{
          this.rollpot += this.pot + 1;
        }

        this.roller1.start( 2, this.offsets[luck][0], this.stopped );
        this.roller2.start( 3, this.offsets[luck][1], this.stopped );
        this.roller3.start( 4, this.offsets[luck][2], this.stopped );
        this.isRolling = true
      }
    },
    stopped: function ( roller, isLast ) {
      roller.getChildAt(1).alpha = 0
      if (isLast) {
        this.isRolling = false
        this.$emit('done', this.pot)
        if (this.pot > 0) {
          this.rollpot = 0;
        }
      }
    },
    handleFileComplete: function (event) {
      this.roller1 = Object.create(slotroller)
      this.roller2 = Object.create(slotroller)
      this.roller3 = Object.create(slotroller)

      let still = preload.getResult('roller-still')
      let moving = preload.getResult('roller-moving')
      let top = preload.getResult('roller-top')

      var roller1 = this.roller1.init(still, moving, top, this)
      roller1.scaleX = roller1.scaleY = 1 // 0.65
      roller1.x = 512-2*225
      roller1.y = 100
      this.stage.addChild( roller1 )

      var roller2 = this.roller2.init(still, moving, top, this)
      roller2.scaleX = roller2.scaleY = 1 // 0.65
      roller2.x = 512-112
      roller2.y = 100
      this.stage.addChild( roller2 )

      var roller3 = this.roller3.init(still, moving, top, this)
      roller3.scaleX = roller3.scaleY = 1 // 0.65
      roller3.x = 512+225 
      roller3.y = 100
      this.stage.addChild( roller3 )
      this.stage.update();
    }
  },
  mounted () {
    this.stage = new createjs.Stage(this.$refs['my-canvas'])
    createjs.Ticker.setFPS(60)
    createjs.Ticker.addEventListener('tick', this.stage)

    let assetPah = './static/'
    assetPah = '/wp-content/themes/kopiraittilankoulu/helpolla/static/'  

    let assetList = [
      {src: assetPah + 'slotmachine_roller_moving.png', id: "roller-moving"},
      {src: assetPah + 'slotmachine_roller_still.png', id: "roller-still"},
      {src: assetPah + 'slotmachine_roller_top.png', id: "roller-top"},
    ]

    preload.addEventListener('complete', (e) => { this.handleFileComplete(e) })
    preload.loadManifest(assetList)
  }
}
</script>

<style>
.canvas-class{
  max-width: 100%;
  max-height: 30vh;
  margin-bottom: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/SlotMachine.vue